import React, { useState } from 'react'
import Clocks from '../components/Clocks'



export default function Contact({config}) {

    return (
        <div className="contactPage-container">
            <div className="contactPage">
                <div className="contact-infos">
                    <span><span>تلفن تماس: </span><span dir='ltr'>{config.phone}</span></span>
                    <span><span>فکس: </span><span dir='ltr'>{config.fax}</span></span>
                    <span><span>ایمیل: </span><span>{config.email}</span></span>
                    <span><span>تلگرام: </span><span className="link-social-contact"><a href={`https://t.me/${config.telegram}`}>{config.telegram}@</a></span></span>
                    <span><span>اینستاگرم: </span><span className="link-social-contact"><a href={`https://instagram.com/${config.instagram}`}>{config.instagram}@</a></span></span>
                    <span><span>آدرس: </span><span>
                    {config.address}</span></span>
                    <span><span>ساعات کاری: </span><span>{config.workHours}</span></span>
                </div>
                <div className="contact-loc">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3237.6980993530105!2d51.39807221526084!3d35.758224480176416!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzXCsDQ1JzI5LjYiTiA1McKwMjQnMDAuOSJF!5e0!3m2!1sen!2s!4v1631471624574!5m2!1sen!2s" width="350" height="300" style={{border:0}} allowfullscreen="" loading="lazy"></iframe>
                </div>
            </div>
            <Clocks />
        </div>
    )
}
